"use client";

import { ArrowUpRight, Shield, Star, GraduationCap, Users, Briefcase, Newspaper, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const organizationalLevels = [{
  level: "TINGKAT NASIONAL",
  roles: "Majelis Pimpinan Nasional, Majelis Pertimbangan Organisasi, Dewan Kehormatan, Dewan Pakar",
  color: "bg-primary"
}, {
  level: "TINGKAT PROVINSI",
  roles: "Majelis Pimpinan Wilayah, Majelis Pertimbangan Organisasi, Dewan Pakar",
  color: "bg-primary"
}, {
  level: "TINGKAT KABUPATEN/KOTA",
  roles: "Majelis Pimpinan Cabang, Majelis Pertimbangan Organisasi, Dewan Pakar",
  color: "bg-primary"
}, {
  level: "TINGKAT PAC",
  roles: "Pimpinan, Penasehat",
  color: "bg-primary"
}, {
  level: "TINGKAT RANTING",
  roles: "Pimpinan, Penasehat",
  color: "bg-primary"
}, {
  level: "TINGKAT ANAK RANTING",
  roles: "Pimpinan, Penasehat",
  color: "bg-primary"
}];
const bidangOrganisasi = [{
  id: 1,
  name: "Organisasi dan Keanggotaan"
}, {
  id: 2,
  name: "Kaderisasi"
}, {
  id: 3,
  name: "Politik, Pertahanan dan Keamanan Nasional"
}, {
  id: 4,
  name: "Hukum, HAM dan Hubungan Lembaga Negara"
}, {
  id: 5,
  name: "Dana, Sarana dan Prasarana"
}, {
  id: 6,
  name: "Ekonomi, UMKM dan Tenaga Kerja"
}, {
  id: 7,
  name: "Sumber Daya Mineral dan Pertambangan"
}, {
  id: 8,
  name: "Pendidikan, SDM, Pariwisata dan Seni Budaya"
}, {
  id: 9,
  name: "Kesehatan, Lingkungan Hidup dan Penanggulangan Bencana"
}, {
  id: 10,
  name: "Pertanian, Perkebunan, Kehutanan, Kelautan dan Perikanan"
}, {
  id: 11,
  name: "Komunikasi, Informasi dan Media Massa"
}, {
  id: 12,
  name: "Keagamaan dan Kerohanian"
}, {
  id: 13,
  name: "Pemberdayaan Perempuan"
}, {
  id: 14,
  name: "Kepemudaan dan Olahraga"
}, {
  id: 15,
  name: "Pembinaan dan Pemberdayaan Wilayah"
}];
export default function Organizationalstructure() {
  const reveal = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="1688" id="organisasi" className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="mx-auto w-full max-w-[1280px] px-5 sm:px-8 lg:px-16">
        
        {}
        <div ref={reveal.ref} className={`text-center mb-24 transition-all duration-700 ${reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <span className="font-mono text-xs uppercase tracking-widest text-primary mb-4 block">Struktur Resmi</span>
          <h1 className="font-default font-bold text-[clamp(2.5rem,5vw,4.5rem)] leading-tight tracking-tighter mb-6">
            STRUKTUR ORGANISASI<br />PEMUDA PANCASILA
          </h1>
          <p className="max-w-2xl mx-auto text-muted-foreground text-lg md:text-xl">
            Struktur organisasi resmi berdasarkan AD/ART Pemuda Pancasila Hasil Musyawarah Besar X Tahun 2019.
          </p>
        </div>

        {}
        <div className="mb-32">
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
            {["MPN", "MPW", "MPC", "PAC", "RANTING", "ANAK RANTING"].map((item, i) => <div key={item} className="flex items-center gap-4" data-index={i}>
                <div className="px-6 py-3 bg-secondary text-secondary-foreground font-bold rounded-lg shadow-md">
                  {item}
                </div>
                {i < 5 && <span className="text-primary font-bold text-xl">↓</span>}
              </div>)}
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-32">
          {organizationalLevels.map((level, i) => <Card key={level.level} data-index={i} className="border border-border shadow-sm overflow-hidden flex flex-col">
              <CardHeader className={`${level.color} py-4`}>
                <CardTitle className="text-white text-sm font-bold tracking-wider uppercase">
                  {level.level}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6 flex-grow">
                <ul className="space-y-3">
                  {level.roles.split(", ").map((role, idx) => <li key={idx} className="flex items-start gap-3 text-sm leading-relaxed">
                      <span className="size-1.5 rounded-lg bg-primary mt-1.5 shrink-0" />
                      {role}
                    </li>)}
                </ul>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-32">
          <Card className="border border-border shadow-sm p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="p-3 bg-primary/10 rounded-lg text-primary">
                <Shield size={24} />
              </div>
              <h3 className="font-bold text-xl">Majelis Pertimbangan Organisasi</h3>
            </div>
            <ul className="space-y-3 text-muted-foreground text-sm">
              <li>• Memberikan pertimbangan organisasi</li>
              <li>• Pengawasan organisasi</li>
              <li>• Evaluasi organisasi</li>
              <li>• Pendampingan organisasi</li>
            </ul>
          </Card>

          <Card className="border border-border shadow-sm p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="p-3 bg-primary/10 rounded-lg text-primary">
                <Star size={24} />
              </div>
              <h3 className="font-bold text-xl">Dewan Kehormatan</h3>
            </div>
            <ul className="space-y-3 text-muted-foreground text-sm">
              <li>• Menjaga kehormatan organisasi</li>
              <li>• Menjaga marwah organisasi</li>
              <li>• Menjaga nilai perjuangan organisasi</li>
            </ul>
          </Card>

          <Card className="border border-border shadow-sm p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="p-3 bg-primary/10 rounded-lg text-primary">
                <GraduationCap size={24} />
              </div>
              <h3 className="font-bold text-xl">Dewan Pakar</h3>
            </div>
            <ul className="space-y-3 text-muted-foreground text-sm">
              <li>• Memberikan kajian</li>
              <li>• Memberikan rekomendasi</li>
              <li>• Memberikan pemikiran strategis</li>
            </ul>
          </Card>
        </div>

        {}
        <div className="mb-32">
          <div className="flex items-center gap-4 mb-12">
            <h2 className="text-3xl font-bold">Bidang Organisasi</h2>
            <div className="h-px flex-grow bg-border" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {bidangOrganisasi.map((bidang, i) => <div key={bidang.id} data-index={i} className="flex items-center gap-4 p-4 bg-muted/30 rounded-lg border border-border/50">
                <span className="font-mono text-xs text-primary font-bold w-6">{bidang.id}.</span>
                <span className="text-sm font-medium">{bidang.name}</span>
              </div>)}
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-32">
          <div>
            <h3 className="text-xl font-bold mb-6 flex items-center gap-2">
              <Users className="text-primary" size={20} /> Perangkat Organisasi
            </h3>
            <div className="space-y-4">
              {["SAPMA PEMUDA PANCASILA", "SRIKANDI PEMUDA PANCASILA", "KOTI MAHATIDANA"].map((item, i) => <div key={item} data-index={i} className="p-4 border border-border rounded-lg font-bold text-sm hover:border-primary transition-colors">
                  {item}
                </div>)}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6 flex items-center gap-2">
              <Briefcase className="text-primary" size={20} /> Badan Profesi
            </h3>
            <div className="space-y-4">
              {["Badan Penyuluhan dan Pembelaan Hukum", "Badan Pengusaha", "Badan Buruh dan Pekerja", "Badan Tani dan Nelayan"].map((item, i) => <div key={item} data-index={i} className="p-4 border border-border rounded-lg text-sm hover:border-primary transition-colors">
                  {item}
                </div>)}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6 flex items-center gap-2">
              <Shield className="text-primary" size={20} /> Badan Non Profesi
            </h3>
            <div className="space-y-4">
              {["Badan Pelaksana Kaderisasi", "Badan Pelaksana KTA", "Badan Penelitian dan Pengembangan", "Badan Kerohanian", "Badan Kesehatan dan Penanggulangan Bencana", "Badan Pengembangan Seni Budaya"].map((item, i) => <div key={item} data-index={i} className="p-4 border border-border rounded-lg text-sm hover:border-primary transition-colors">
                  {item}
                </div>)}
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-32">
          <div className="relative group overflow-hidden rounded-lg aspect-video bg-secondary flex flex-col justify-end p-8">
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="relative z-10">
              <div className="flex items-center gap-2 text-primary mb-2">
                <MapPin size={18} />
                <span className="text-xs font-bold uppercase tracking-widest">Wilayah</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">MPW JAWA BARAT</h3>
              <p className="text-white/70 text-sm">Struktur wilayah Jawa Barat</p>
            </div>
          </div>

          <div className="relative group overflow-hidden rounded-lg aspect-video bg-primary flex flex-col justify-end p-8">
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="relative z-10">
              <div className="flex items-center gap-2 text-white mb-2">
                <Star size={18} />
                <span className="text-xs font-bold uppercase tracking-widest">Pilot Project</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">MPC GARUT</h3>
              <p className="text-white/70 text-sm">Pilot Project Zona PP Jawa Barat</p>
            </div>
          </div>
        </div>

        {}
        <div className="mb-32">
          <div className="flex items-center justify-between mb-12">
            <h2 className="text-3xl font-bold flex items-center gap-3">
              <Newspaper className="text-primary" /> Berita Organisasi Terbaru
            </h2>
            <Link to="/PPZonePage" className="text-primary font-bold text-sm flex items-center gap-2 group">
              Lihat Semua <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {}
            {[1, 2, 3].map(i => <article key={i} data-index={i} className="group">
                <div className="aspect-[16/10] bg-muted rounded-lg mb-4 overflow-hidden">
                  <div className="w-full h-full bg-muted animate-pulse" />
                </div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-primary/10 text-primary text-[10px] font-bold uppercase rounded-lg">Zona PP</span>
                  <span className="text-[10px] text-muted-foreground">Baru Saja</span>
                </div>
                <h4 className="font-bold leading-snug group-hover:text-primary transition-colors">
                  Memperkuat Sinergi Organisasi Melalui Konsolidasi Wilayah
                </h4>
              </article>)}
          </div>
        </div>

        {}
        <div className="pt-20 border-t border-border text-center">
          <div className="flex justify-center mb-8">
            <Link to="/">
              <WvcLogo className="h-12 w-auto" />
            </Link>
          </div>
          <h2 className="font-serif italic text-3xl md:text-4xl text-foreground mb-4">
            "SEKALI LAYAR TERKEMBANG SURUT KITA BERPANTANG"
          </h2>
          <p className="text-muted-foreground text-sm font-mono uppercase tracking-widest">
            Pancasila! Abadi!
          </p>
        </div>

      </div>
    </section>;
}